import type { FreightClaim } from "@freightsimple/generated-dashboard-openapi-client/models/FreightClaim";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Table } from "@freightsimple/ui-core/Table/Table";
import { T } from "@freightsimple/ui-core/Typography/T";
import type { Column } from "@freightsimple/ui-core/Table/Table";
import { FilePdfIcon } from "@phosphor-icons/react/FilePdf";
import type { DocumentsSectionItem } from "@/Shared/Shipment/CustomComponents/ShipmentDocumentsSectionGeneric";
import { ShipmentDocumentDownloadButton } from "@/Shared/Shipment/CustomComponents/ShipmentDocumentDownloadButton";

// Matches the shipment's own Documents section: same columns, same date
// treatment, same download affordance. It is the same kind of list, so it
// should not be a differently-styled one just because it hangs off a claim.
const columns: Column<DocumentsSectionItem>[] = [
  {
    key: "document",
    header: "Document",
    render: (item) => (
      <Row gap={2}>
        <Icon icon={FilePdfIcon} size="md" color="text-content-faint" />
        <T>{item.documentDescription}</T>
      </Row>
    ),
  },
  {
    key: "date",
    header: "Date",
    render: (item) => (
      <T weight="light" color="muted">
        {item.existsYet
          ? item.creationDate?.format("Do MMMM YYYY")
          : "Not yet available"}
      </T>
    ),
  },
];

export function ViewShipmentsFreightClaimRowDocumentsTable({
  documents,
  freightClaim,
}: {
  documents: DocumentsSectionItem[];
  freightClaim: FreightClaim;
}) {
  const claimsDocsIds = [
    ...(freightClaim.otherDocumentFiles ?? []),
    ...(freightClaim.originalInvoiceFiles ?? []),
    ...(freightClaim.photoFiles ?? []),
  ];
  const claimDocuments = documents.filter((doc) =>
    claimsDocsIds.includes(doc.documentId ?? ""),
  );
  return (
    <Table
      columns={columns}
      data={claimDocuments}
      rowKey={(item) => item.documentId ?? item.documentDescription}
      emptyMessage="No documents were attached to this claim"
      rowActions={(item) =>
        item.existsYet && (
          <ShipmentDocumentDownloadButton
            onDownloadDocument={item.onDownloadDocument}
          />
        )
      }
    />
  );
}
